
import Schema from 'AppReact/schema';
import { today } from 'AppReact';

export default {
  selectedDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  month: Schema('integer', 'primitive', { defaultValue: today().getMonth() }),
  year: Schema('integer', 'primitive', { defaultValue: today().getFullYear() }),
  selectedPeriod: Schema('jsDate', 'array', { defaultValue: null }),
  disabledBefore: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  disabledAfter: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  hasRemove: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  borderless: Schema('boolean', 'primitive-nullable', { defaultValue: false }),
  borderRadius: Schema('string', 'primitive-nullable', { defaultValue: null }),
}